// extracted by mini-css-extract-plugin
export var alignCenter = "trustBadges-module--align-center--zEVK6";
export var badges = "trustBadges-module--badges--UBSK6";
export var bankIcon = "trustBadges-module--bank-icon--2jLQa";
export var banks = "trustBadges-module--banks--K35oT";
export var boletoBadge = "trustBadges-module--boleto-badge--2irGc";
export var darkTheme = "trustBadges-module--dark-theme--QtKwH";